import { Box } from '@material-ui/core';
import { getLoanById, OnboardingDetailsType } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { DigitalFootprint } from '@/components/modules/KYC/KYCOrder/components/DigitalFootprint/DigitalFootprint';
import { Otp } from '@/components/modules/KYC/KYCOrder/components/Otp/Otp';
import { PersonalInformation } from '@/components/modules/KYC/KYCOrder/components/PersonalInformation/PersonalInformation';
import { useCache } from '@/hooks/requests/useCache';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

export const KYCOrder = () => {
  const { loanId } = useParams();
  if (!loanId) return null;

  const { data: loan, loading } = useCache(getLoanById, { loanId });

  if (loan?.onboardingDetails[0].type !== OnboardingDetailsType.ONLINE) return <></>;
  const onboardingDetails = loan?.onboardingDetails[0];

  return (
    <>
      <PersonalInformation onboardingDetails={onboardingDetails} loading={loading} />
      <Box mt={3} />
      <DigitalFootprint onboardingDetails={onboardingDetails} loading={loading} />
      <Box mt={3} />
      <Otp loanId={loanId} loading={loading} />
    </>
  );
};

export const KYCOrderModule = withPermissionsModule(KYCOrder);
